export default "__VITE_ASSET__DM7VALQV__"